import FroalaEditor from  'froala-editor/js/froala_editor.pkgd.min'

import 'froala-editor/js/plugins/align.min'
import 'froala-editor/js/plugins/char_counter.min'
import 'froala-editor/js/plugins/code_view.min'
import 'froala-editor/js/plugins/file.min'
import 'froala-editor/js/plugins/fullscreen.min'
import 'froala-editor/js/plugins/help.min'
import 'froala-editor/js/plugins/image.min'
import 'froala-editor/js/plugins/link.min'
import 'froala-editor/js/plugins/lists.min'
import 'froala-editor/js/plugins/paragraph_format.min'
import 'froala-editor/js/plugins/quote.min'
import 'froala-editor/js/plugins/special_characters.min'
import 'froala-editor/js/plugins/table.min'
import 'froala-editor/js/plugins/video.min'


FroalaEditor.DefineIcon('insertCode', {NAME: 'code', template: 'font_awesome'})
FroalaEditor.RegisterCommand('insertCode', {
  title: 'Code Block',
  focus: true,
  undo: true,
  refreshAfterCallback: true,
  callback: function() {
    const selection = this.html.getSelected()

    var htmlCode = "<pre><code>" + selection + "</code></pre>";
    var codeBlock = "<div class='st__content-block st__content-block--code'>" + htmlCode + "</div>";

    this.html.insert(codeBlock, true);
  }
})

export default FroalaEditor;
